/**
 * Portuguese (Brazil) Translation Resources
 */

import common from './common.json';
import navigation from './navigation.json';
import marketing from './marketing.json';
import dashboard from './dashboard.json';
import auth from './auth.json';
import educational from './educational.json';
import errors from './errors.json';
import validation from './validation.json';

export default {
  common,
  navigation,
  marketing,
  dashboard,
  auth,
  educational,
  errors,
  validation,
};
